import React from 'react';
import { FormattedMessage } from 'react-intl';

export default () => (
    <div className="notification is-link">
        <FormattedMessage id="contactForm.successMessage" />
    </div>
);



// WEBPACK FOOTER //
// ./src/components/ConferenctProgramForm/components/SuccessNotification.js